/* eslint-disable react/no-unescaped-entities */
import CookieConsentBanner from '@components/Cookie/CookieConsentBanner';
import Header from '@components/Header/Header';
import colors from '@styles/common/colors';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Seo from '@components/SEO/Seo';
import VatImage from '@assets/images/30804-1-Moha-Leap-(274).jpg';
import { logEvent } from 'firebase/analytics';
import { analytics } from '@database/firebase';
import Footer from '@components/Footer/Footer';
import typography from '@styles/common/typography';

const Author: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    logEvent(analytics, 'AuthorPage');
  }, []);

  return (
    <>
      <Seo
        title={t('header.author') + ' | La Pagode Khmère'}
        description={t('metatag.author.description')}
        type={'website'}
        name={'La Pagode Khmère'}
        url={'https://lapagodekhmere.com/author'}
        image={VatImage}
      />
      <Header />
      {/* <Banner /> */}
      <Layout>
        <Title>{t('header.author')}</Title>
        <Content>{t('author.content-1')}</Content>
        <Content>{t('author.content-2')}</Content>
        <Content>{t('author.content-3')}</Content>
        <Content>{t('author.content-5')}</Content>
        <Content>{t('author.content-6')}</Content>
        <Content>{t('author.content-7')}</Content>
        <Content>{t('author.content-8')}</Content>
      </Layout>
      <Footer />
      <CookieConsentBanner />
    </>
  );
};

export default Author;

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 15px;

  @media (min-width: 320px) {
    padding: 100px 30px;
  }
  @media (min-width: 768px) {
    padding: 100px 15px;
  }
  @media (min-width: 768px) {
    padding: 100px 15px;
  }
  @media (min-width: 1024px) {
    padding: 100px 53px;
  }
  @media (min-width: 1280px) {
    padding: 100px 180px;
  }
  @media (min-width: 1440px) {
    padding: 100px 380px;
  }
  @media (min-width: 1920px) {
    padding: 100px 590px;
  }
`;

const Title = styled.div`
  font-size: ${typography.fontSize['3xl']};
  font-weight: bold;
  color: ${colors.dark_tangerine};
  letter-spacing: 1px;
  text-align: center;
  margin-bottom: 16px;

  @media (min-width: 1280px) {
    font-size: ${typography.fontSize['4xl']};
  }
`;

const Content = styled.div`
  font-size: ${typography.fontSize.md};
  color: ${colors.text_grey};
  line-height: 24px;
  letter-spacing: 0.5px;
  margin-bottom: 12px;

  @media (min-width: 1024px) {
    font-size: ${typography.fontSize.lg};
    line-height: 26px;
  }
  @media (min-width: 1440px) {
    font-size: ${typography.fontSize.xl};
    line-height: 30px;
  }
`;
